import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65174736"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "single-experience" }
const _hoisted_2 = { class: "single-experience__img" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["href"]

import { DayExperience } from "@/models/DayExperience";


interface Props {
  experience: DayExperience;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SingleExperience',
  props: {
    experience: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: __props.experience.img,
        alt: __props.experience.name
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("header", null, [
      _createElementVNode("h3", null, _toDisplayString(__props.experience.name), 1),
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.experience.location, (location, index) => {
          return (_openBlock(), _createElementBlock("span", { key: index }, [
            _createTextVNode(_toDisplayString(location), 1),
            (index != __props.experience.location.length - 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, ", "))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("p", null, _toDisplayString(__props.experience.description), 1),
    _createElementVNode("footer", null, [
      _createElementVNode("p", null, _toDisplayString(__props.experience.price), 1),
      _createElementVNode("a", {
        href: __props.experience.permalink
      }, "Find out more", 8, _hoisted_5)
    ])
  ]))
}
}

})